// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2NEjV","additionalInfo":"AgreementModal_additionalInfo__2OClw"};